module.exports = __webpack_public_path__ + "static/img/eicad_function02.c21cc74d.png";